import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Widerrufsbelehrung: React.FC = () => {
  useEffect(() => {
    // Add meta robots tag to prevent indexing
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex, nofollow';
    document.head.appendChild(metaRobots);

    // Clean up function to remove the meta tag when component unmounts
    return () => {
      const existingTag = document.querySelector('meta[name="robots"]');
      if (existingTag) {
        document.head.removeChild(existingTag);
      }
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h1 className="text-2xl font-bold text-deep-blue mb-6">Widerrufsbelehrung</h1>
          
          <section className="mb-8">
            <p className="mb-6">
              Verbraucher haben bei Abschluss eines Fernabsatzgeschäfts ein gesetzliches Widerrufsrecht, über das der Anbieter nach Maßgabe des gesetzlichen Musters nachfolgend informiert.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">Widerrufsrecht</h2>
            <p className="mb-4">
              Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.
            </p>
            <p className="mb-4">
              Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsschlusses.
            </p>
            <p className="mb-4">
              Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (YN Digital GmbH, Am Schulhof 23, 28865 Lilienthal, E-Mail: <a href="mailto:info@adressfinder.org" className="text-blue-600 hover:underline">info@adressfinder.org</a>, Telefonnummer: +49 4065725668) mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief oder eine E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.
            </p>
            <p className="mb-4">
              Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">Folgen des Widerrufs</h2>
            <p className="mb-4">
              Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">Muster-Widerrufsformular</h2>
            <div className="border-2 border-black p-4 mb-4">
              <p className="mb-4"><em>(Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es zurück.)</em></p>
              
              <p className="mb-4">
                An YN Digital GmbH, Am Schulhof 23, 28865 Lilienthal, E-Mail: <a href="mailto:info@adressfinder.org" className="text-blue-600 hover:underline">info@adressfinder.org</a>:
              </p>
              
              <ul className="list-disc pl-6 space-y-2">
                <li>Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden Waren (*) / die Erbringung der folgenden Dienstleistung (*),</li>
                <li>Bestellt am (*) / erhalten am (*),</li>
                <li>Name des/der Verbraucher(s),</li>
                <li>Anschrift des/der Verbraucher(s),</li>
                <li>Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier),</li>
                <li>Datum.</li>
              </ul>
              
              <p className="mt-4">(*) Unzutreffendes streichen</p>
            </div>
          </section>
          
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">Besondere Hinweise</h2>
            <p className="mb-4">
              Das Widerrufsrecht erlischt vorzeitig, wenn wir auf Ihre ausdrückliche Anforderung hin noch vor Ablauf der Widerrufsfrist mit der Ausführung der Dienstleistung beginnen und die Dienstleistung vollständig erbracht ist. Bei unseren Services bedeutet dies insbesondere, dass Ihr Widerrufsrecht erlischt, sobald wir in Ihrem Auftrag eine Anfrage an das zuständige Melderegister gestellt haben.
            </p>
          </section>
          
          <div className="mt-8">
            <Link to="/" className="text-blue-600 hover:underline">Zurück zur Startseite</Link>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Widerrufsbelehrung;
